import { render, staticRenderFns } from "./SubmitalNavTabs.vue?vue&type=template&id=1071e581&"
import script from "./SubmitalNavTabs.vue?vue&type=script&lang=js&"
export * from "./SubmitalNavTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports